import { IAppState } from "store/app-state";
import { useSelector } from "react-redux";
import { loadExperiments } from "utils/storage";

export const useExperiments = () => {
  const experimentsState = useSelector((state: IAppState) => state.experiments.experiments);
  const experiments = loadExperiments() || experimentsState;

  return experiments;
};
